module.exports = __webpack_public_path__ + "img/bourriche-ostra-regal.ce28696c.webp";